import { cooperplaceApi } from 'services/api';
import { validate } from '../shared/validator';

export async function handleCreation(
  data,
  setErrors,
  showSnackbar,
  setLoading,
  navigate
) {
  const isDataValid = await validate('createSchema', data, setErrors);

  if (!isDataValid) {
    showSnackbar('Verifique os campos obrigatórios!', { type: 'error' });
    return false;
  }
  let createdId = null;
  try {
    setLoading(true);
    const payload = {
      plate: data?.plate,
      yearModel: data?.yearModel,
      yearManufacture: data?.yearManufacture,
      chassi: data?.chassi,
      renavam: data?.renavam,
      antt: data?.antt,
      rntrcExpDate: data?.rntrcExpDate,
      totalGrossWeight: data?.totalGrossWeight,
      tareMass: data?.tareMass,
      cubage: data?.cubage,
      brand: data?.brand?.name,
      color: data?.color?.label,
      idOwner: data?.owner?.id,
      plateCityId: data?.city?.id,
      plateCity: data?.city?.name,
      plateCityId: data?.city?.id,
      plateState: data?.city?.province?.uf,
      model: data?.model?.label,
      anttType: data?.anttType?.id,
      manufacturerId: data?.brand?.id,
      vehicleTypeId: data?.vehicleType?.id,
      vehicleBodyTypeId: data?.bodyType?.id,
      anttAdherence: data?.anttAdherence,
      beneficiaryId: data?.beneficiary.id
    };

    const response = await cooperplaceApi.post('vehicleBodies', payload);
    createdId = response.data.id;
    showSnackbar('Carroceria cadastrada com sucesso!', { type: 'success' });
  } catch (error) {
    showSnackbar('Erro ao cadastrar carroceria!', { type: 'error' });
    if (error.response) {
      const errors = error?.response?.data;
      if (errors && Array.isArray(errors)) {
        setErrors(old => ({
          ...old,
          ...Object.fromEntries(
            errors?.map(error => [error?.field, error?.message])
          ),
        }));
      }
    }
  } finally {
    setLoading(false);
    if (createdId) {
      setTimeout(() => {
        navigate(`/carrocerias/${createdId}`);
      }, 500);
    } else {
      navigate('/carrocerias');
    }
  }
}
